module.exports = __webpack_public_path__ + "assets/img/ticket.e4b1d6b3.png";